import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useLabelsLiveUpdates} from '../../../hooks/use-labels-live-updates'
import {pullRequestsLayoutRoute} from '../../../routes/layout-route'
import {useLabelsQuery} from './route-queries'

export function useLabels() {
  const {data: layoutData} = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  useLabelsLiveUpdates(layoutData?.aliveChannels)

  return useLabelsQuery()
}
